import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./index.css";
import BannerContent from "./BannerContent";
import shouldEnableBanner from "./shouldEnableBanner";
import { getCategoryId } from "../../../state/modules/category";
import {
  getIsBenefitAvailable,
  getLoyaltyMemberOnlySaleEvent,
  getStoreCode
} from "../../../state/modules/config/selectors";
import { MEMBERS_ONLY_SALE } from "../../../state/modules/config/constants";

const LoyaltyMembersDayBanner = () => {
  const bannerRef = useRef(null);

  const categoryId = useSelector(getCategoryId);
  const isBenefitAvailable = useSelector(getIsBenefitAvailable);
  const membersDayEvent = useSelector(getLoyaltyMemberOnlySaleEvent);
  const storeCode = useSelector(getStoreCode);

  const isMembersDayAvailable = isBenefitAvailable?.[MEMBERS_ONLY_SALE];

  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(
      shouldEnableBanner({
        categoryId,
        isMembersDayAvailable,
        membersDayEvent,
        storeCode
      })
    );
  }, [categoryId, isMembersDayAvailable, membersDayEvent, storeCode]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={styles.loyaltyMembersDayBanner} ref={bannerRef}>
      <BannerContent membersDayEvent={membersDayEvent} />
    </div>
  );
};

export default LoyaltyMembersDayBanner;
